import { ContextProvider } from "components/table/employee/Context";
import { Table } from "components/table/employee/Table";
const Employees = () => {

	return (
		<ContextProvider value={{}}>
			<Table />
		</ContextProvider>
	);
};

export { Employees };
